<template>
    <div :class="[`fs5-notice-card-v5`, cardClassType]" @click="toggleCollapse">
        <div class="header">
            <img class="avatar" :src="view.imgAvatar" />
            <div class="content">
                <div class="title" v-html="view.title" ></div>
                <div class="subject" v-html="view.subject"></div>
                <div class="text-wrapper" :class="{ 'collapsed': !collapsed }">
                    <p class="text" v-html="view.description"></p>
                </div>
                <div class="date">{{formatedDate}}</div>
            </div>
            <div class="arrow">
                <i :class="['fa fa-chevron-down', !collapsed ? '' : 'rotate-180']" ></i>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "fs5-notice-card-v5",
        props: ['view', 'lang', 'langs'],
        data: function() {
            return {
                collapsed: true
            }
        },
        methods: {
            toggleCollapse(){
                this.collapsed = !this.collapsed
            }
        },
        mounted() {
            // console.log('view: ', this.view);
        },
        computed: {
            formatedDate() {
                let dt = new Date( this.view.created_at );
                moment.locale( this.langs[this.lang].locale.toLowerCase().replace('_', '-') );
                let mdt = moment(dt);

                let formatedDate = '';
                switch(this.lang){
                    case 'br':
                        formatedDate = mdt.format('DD/MM/YYYY HH:mm:ss');
                        break;
                    case 'us':
                        formatedDate = mdt.format('MM/DD/YYYY hh:mm:ss A');
                        break;
                    default:
                        formatedDate = mdt.format('MM/DD/YYYY hh:mm:ss A');
                        break;
                }

                return formatedDate
            },
            cardClassType(){
                switch(this.view.show_on) {
                    case 'MURAL_AFFILIATE':
                        return 'affiliate';
                    case 'MURAL_CONCESSIONAIRE':
                        return 'concessionaire';
                    case 'MURAL_AMBASSADOR':
                        return 'ambassador'
                    default:
                        return '';
                }
            }
        }
    }
</script>

<style scoped lang="scss" >
    @import '../../../../scss/extras/_variables';
    .fs5-notice-card-v5{
        font: inherit;
        background-color: $fs5-color2;
        border: 1px $fs5-color1 solid;
        border-radius: 0.8em;
        padding: 1.6em 2.6em 1.6em 1.6em;
        margin-top: 2.3em;
        &:hover{
            cursor: pointer;
        }

        &.ambassador{ // azul
            border-color: $fs5-color29;
            .header{
                .content{
                    .title,
                    .subject{
                        color: $fs5-color-26;
                    }
                }
                .arrow{
                    .fa{
                        &::before{
                            color: $fs5-color5!important;
                        }
                    }
                }
            }
        }

        &.concessionaire{ // verde
            border-color: $fs5-color30;
            .header{
                .content{
                    .title,
                    .subject{
                        color: $fs5-color31;
                    }
                }
                .arrow{
                    .fa{
                        &::before{
                            color: $fs5-color30!important;
                        }
                    }
                }
            }
        }

        &.affiliate{ // roxo
            border-color: $fs5-color32;
            .header{
                .content{
                    .title,
                    .subject{
                        color: $fs5-color33;
                    }
                }
                .arrow{
                    .fa{
                        &::before{
                            color: $fs5-color32!important;
                        }
                    }
                }
            }
        }

        .header{
            font: inherit;
            display: grid;
            grid-template-columns: 4.5em auto 2.2em;
            grid-template-rows: auto;
            justify-content: stretch;
            align-items: start;
            column-gap: 1.6em;

            .avatar{
                font: inherit;
                border-radius: 50%;
                width: 4.2em;
                height: auto;
                margin-top: 1.2em;
            }

            .content{
                font: inherit;

                .title{
                    font: inherit;
                    text-align: left;
                    font-size: 1.6em;
                    font-weight: 700;
                    line-height: 1.2;
                    color: $fs5-color10;
                    padding: 0!important;

                    margin-bottom: 0.25em;
                }
                .subject{
                    font-size: 1.45em;
                    font-weight: 800;
                    padding: 0 0 .4em;
                }
                .text-wrapper{
                    font: inherit;
                    // margin-bottom: 1em;
                    max-height: 3.36em;
                    overflow: hidden;

                    display: -webkit-box;
                    -webkit-line-clamp: 2;
                    -webkit-box-orient: vertical;
                    text-overflow: ellipsis;

                    &.collapsed{
                        max-height: none!important;
                        transition: .8s;
                        padding: 0 0 !important;

                        display: block;
                    }

                    .text{
                        font: inherit;
                        font-size: 1.4em;
                        line-height: 1.2;
                        font-weight: 400;
                        color: $fs5-color19;

                        text-align: justify;
                        text-overflow: ellipsis;
                    }
                }
                .date{
                    font: inherit;
                    text-align: right;
                    font-size: 1em;
                    line-height: 1.2;
                    font-weight: 400;
                    color: $fs5-color11;
                    margin-bottom: -0.8em;
                }
            }
            .arrow{
                font: inherit;
                margin-top: 2.9em;
                .fa{
                    font-size: inherit;
                    &::before{
                        color: $fs5-color11!important;
                        font-size: inherit;
                        font-size: 2em;
                    }
                }
            }
            .rotate-180{
                transform: rotate(180deg);
            }
            .fa-chevron-down{
                transition: transform .3s ease-in-out;
            }
        }
    }
</style>


// WEBPACK FOOTER //
// resources/office/js/components/franchise_v5/notice_board/notice_card.vue